/**
 * Created by superman on 17/2/16.
 * http配置
 */
import { Loading } from 'element-ui';

let loading;
let loadingCount = 0;

const startLoading = () => {
  loading = Loading.service({
    lock: false,
    text: "Loading...",
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.2)',
    fullscreen: true
  });
};

const endLoading = () => {
  loading.close();
};

export const showLoading = (msg) => {
  if (loadingCount === 0) {
    startLoading();
  }
  loading.text = msg;
  loadingCount += 1;
};

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};
